import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    effect,
    forwardRef,
    HostBinding,
    inject,
    input,
    model,
    output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {
    ControlContainer,
    FormGroupDirective,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule
} from '@angular/forms';
import { ZFloatEmailComponent } from '@shared/components/form-components/z-float-email/z-float-email.component';
import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import {
    CustomerType,
    InvoiceType
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { ButtonModule } from 'primeng/button';
import { InvoiceCardHeaderAddressComponent } from '../../invoice-card-header-address/invoice-card-header-address.component';
import { FieldsetModule } from 'primeng/fieldset';
import { ZCustomerSelectComponent } from '../../../../../../shared/components/bussiness-components/z-customer-select/z-customer-select.component';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ZClientCardComponent } from '@portal/clients/z-client-card/z-client-card.component';
import { ZClientCardFooterComponent } from '@portal/clients/z-client-card-footer/z-client-card-footer.component';
import { ClientCardOptions } from '@portal/clients/entities/client-card.options';
import { ObjectId } from 'zigra-ng-framework';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
    selector: 'z-invoice-card-customer',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        FieldsetModule,
        ZCustomerSelectComponent,
        FloatLabelModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InvoiceCardCustomerComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: InvoiceCardCustomerComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './invoice-card-customer.component.html',
    styleUrl: './invoice-card-customer.component.scss'
})
export class InvoiceCardCustomerComponent {
    //formGroupA = input<InvoiceTypeFormGroup | undefined>(); // new InvoiceTypeFormGroup();

    // self-center
    @HostBinding('class') class?: string = 'flex grow ';

    @ViewChild('invoiceCardHeaderAddress')
    invoiceCardHeaderAddress?: InvoiceCardHeaderAddressComponent;
    protected rootFormGroup = inject(FormGroupDirective);
    protected cd = inject(ChangeDetectorRef);

    protected dialogService = inject(DialogService);
    selectedCustomer = model<CustomerType | undefined>();
    customerSelected = output<{
        customerType: CustomerType | undefined;
        rowIndex?: number;
    }>();

    modelChange = output<ObjectId | undefined>();

    disabled = input<boolean | undefined>();

    invoice?: InvoiceType;

    constructor() {
        // effect(() => {
        //     console.debug(this.selectedCustomer());
        //     this.detectChanges();
        // });
        // 1. this.invoice?.CounterPart?.Code;
        // 2. this.invoice?.CounterPart?.Name;
        // 3. this.invoice?.CounterPart?.Occupation;
        // 4.1 this.invoice?.CounterPart?.Address?.Country;
        // 4.2 this.invoice?.CounterPart?.Address?.CityEx
        // 4.3 this.invoice?.CounterPart?.Address?.StreetName
        // 4.4 this.invoice?.CounterPart?.Address?.StreetNumber;
        // 4.5 this.invoice?.CounterPart?.Address?.PostalCode;
        // 5. this.invoice?.CounterPart?.VATNumber
        // 6. this.invoice?.CounterPart?.TAXOffice
        // 7. this.invoice?.CounterPart?.Branch;
    }

    detectChanges() {
        this.cd.detectChanges();
        this.invoiceCardHeaderAddress?.detectChanges();
    }

    // onCustomerModelChange(customerId?: ObjectId) {}

    editCustomer(customer: CustomerType) {
        const dialogRef = this.dialogService.open<ZClientCardComponent>(
            ZClientCardComponent,
            {
                header: 'Μεταβολή Καρτέλας Πελάτη',
                height: '700px',
                width: '1100px',
                modal: true,
                resizable: true,
                draggable: true,
                closable: true,
                maximizable: false,
                closeOnEscape: false,
                focusOnShow: false,
                templates: {
                    footer: ZClientCardFooterComponent
                },
                data: {
                    customerId: customer?._id, // this.selectedCustomer()?._id,
                    mode: 'edit',
                    onSave: (options, customer) => {
                        this.selectedCustomer.set(customer);
                        this.customerSelected.emit({
                            customerType: customer,
                            rowIndex: 0
                        });
                        dialogRef.close();
                    }
                } as ClientCardOptions
            } as DynamicDialogConfig<ClientCardOptions>
        );
    }

    newCustomer() {
        const dialogRef = this.dialogService.open<ZClientCardComponent>(
            ZClientCardComponent,
            {
                header: 'Νέα Καρτέλα Πελάτη',
                height: '700px',
                width: '1100px',
                modal: true,
                resizable: true,
                draggable: true,
                closable: true,
                maximizable: false,
                closeOnEscape: false,
                focusOnShow: false,
                templates: {
                    footer: ZClientCardFooterComponent
                },
                data: {
                    customerId: undefined,
                    mode: 'add',
                    onSave: (options, customer) => {
                        this.selectedCustomer.set(customer);
                        this.customerSelected.emit({
                            customerType: customer,
                            rowIndex: 0
                        });
                        dialogRef.close();
                    }
                } as ClientCardOptions
            } as DynamicDialogConfig<ClientCardOptions>
        );
    }
}
